module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/img_feature02-2d9e0d323dfc4cf785e6870256772eec.jpg";